import React, { useState } from 'react';
import { Section } from '../ui/Section';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: '¿Cómo accedo al producto después de comprar?',
  answer: 'Apenas confirmás tu compra, recibís un email con acceso inmediato a todos los tomos y bonos. Todo digital, todo en un solo lugar.'
}, {
  question: '¿Necesito tener mucho tiempo libre para aplicar el método?',
  answer: 'No. El método está diseñado para mujeres con una vida ocupada. Podés empezar con 10 minutos al día.'
}, {
  question: '¿En cuánto tiempo voy a ver resultados?',
  answer: 'Muchas mujeres notan cambios en los primeros 5 a 7 días. Cada persona es diferente, pero el método está pensado para resultados rápidos y reales.'
}, {
  question: '¿Qué pasa si no me funciona?',
  answer: 'Tenés una garantía de satisfacción. Si sentís que no fue lo que esperabas, te devolvemos el dinero sin preguntas.'
}, {
  question: '¿Es solo para mujeres con mucho cansancio?',
  answer: 'Es para cualquier mujer que sienta que su energía no alcanza, que el día pesa más de lo que debería y que quiere recuperar su claridad sin agregar más cosas a su vida.'
}];
function AccordionItem({
  question,
  answer,
  isOpen,
  onToggle,
  index
}: {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
  index: number;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 12
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.4,
    delay: index * 0.08
  }} className="border-b border-dusty-rose/20 last:border-b-0" data-id="element-86">
      <button onClick={onToggle} className="w-full flex items-center justify-between py-5 md:py-6 text-left gap-4 group" aria-expanded={isOpen} data-id="element-87">
        <span className="text-base md:text-lg font-semibold text-navy leading-snug pr-2" data-id="element-88">
          {question}
        </span>
        <span className="flex-shrink-0 w-8 h-8 rounded-full border border-dusty-rose/30 flex items-center justify-center transition-colors duration-300 group-hover:bg-dusty-rose/10" data-id="element-89">
          {isOpen ? <Minus className="w-4 h-4 text-warm-gold" data-id="element-90" /> : <Plus className="w-4 h-4 text-warm-gold" data-id="element-91" />}
        </span>
      </button>
      <AnimatePresence initial={false} data-id="element-92">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.35,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-93">
            <p className="pb-5 md:pb-6 text-navy/70 text-base leading-relaxed font-light pr-12" data-id="element-94">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <Section background="white" containerSize="sm" data-id="element-95">
      <div className="text-center mb-10 md:mb-14" data-id="element-96">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif italic text-navy mb-4" data-id="element-97">
          Preguntas Frecuentes
        </h2>
        <div className="flex items-center justify-center gap-3" data-id="element-98">
          <div className="w-12 h-px bg-warm-gold/40" data-id="element-99" />
          <div className="w-2 h-2 rounded-full bg-warm-gold/50" data-id="element-100" />
          <div className="w-12 h-px bg-warm-gold/40" data-id="element-101" />
        </div>
      </div>

      <div className="max-w-2xl mx-auto bg-white/60 backdrop-blur-sm rounded-2xl border border-dusty-rose/15 px-6 md:px-10 py-2 shadow-sm" data-id="element-102">
        {faqs.map((faq, index) => <AccordionItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onToggle={() => handleToggle(index)} index={index} data-id="element-103" />)}
      </div>
    </Section>;
}